var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getHeaderImage !== '')?_c('div',{staticClass:"calculator-banner"},[_c('img',{staticClass:"full-width",attrs:{"src":_vm.getHeaderImage,"alt":"Calculator Banner"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }